import { render, staticRenderFns } from "./PotentialResourcesRule.vue?vue&type=template&id=ca4eebf8&scoped=true&"
import script from "./PotentialResourcesRule.vue?vue&type=script&lang=js&"
export * from "./PotentialResourcesRule.vue?vue&type=script&lang=js&"
import style0 from "./PotentialResourcesRule.vue?vue&type=style&index=0&id=ca4eebf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4eebf8",
  null
  
)

export default component.exports